// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "label[data-v-5f4eeea6] {\n  font-size: 11px;\n  color: #828282;\n}\n.form-control[data-v-5f4eeea6] {\n  padding-left: 0;\n  color: #19191c;\n  border-color: #828282;\n}\n@media (min-width: 760px) {\n.offset[data-v-5f4eeea6] {\n    margin-left: 200px;\n}\n}", ""]);
// Exports
module.exports = exports;
